import { useCompanies, useUsers } from '@adsk/alloy-provider';

interface UserData {
  autodeskId?: string;
  isLoading: boolean;
  name?: string;
  company?: string;
}

export default function useUserData(userIds: string[]): UserData[] {
  const { data: users, loading } = useUsers();
  const { data: companies } = useCompanies();
  let usersData: UserData[] = [];
  userIds.forEach((userId) => {
    const user = users.find((user) => user.autodeskId === userId);
    if (!user) {
      usersData = [...usersData, { isLoading: loading }];
    } else {
      const company = companies.find(
        (company) => company.id === user.companyId,
      );
      usersData = [
        ...usersData,
        {
          name: user.name,
          company: company ? company.name : undefined,
          autodeskId: user.autodeskId,
          isLoading: false,
        },
      ];
    }
  });
  return usersData;
}
